export default __webpack_public_path__ + "static/media/Hemlata-Chauhan.adeeb49d.jpg";